import { useTranslation } from "react-i18next";
import {
  PageWrap,
  Section,
  Title,
  Subtitle,
  H2,
  H3,
  P,
  Ul,
  Ornament,
} from "./LegalStyles";

export default function PrivacyPage() {
  const { t } = useTranslation();

  const bulletsDataWeCollect = t("legal.privacy.collect.bullets", {
    returnObjects: true,
  });
  const bulletsUseOfData = t("legal.privacy.use.bullets", {
    returnObjects: true,
  });
  const bulletsRights = t("legal.privacy.rights.bullets", {
    returnObjects: true,
  });

  return (
    <PageWrap>
      <Ornament />
      <Section>
        <Title>{t("legal.privacy.title")}</Title>
        <Subtitle>{t("legal.privacy.subtitle")}</Subtitle>
      </Section>

      <Section>
        <H2>{t("legal.privacy.intro.h2")}</H2>
        <P>{t("legal.privacy.intro.p1")}</P>
        <P>{t("legal.privacy.intro.p2")}</P>
      </Section>

      <Ornament />

      <Section>
        <H2>{t("legal.privacy.collect.h2")}</H2>
        <P>{t("legal.privacy.collect.p1")}</P>
        <Ul>
          {bulletsDataWeCollect.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>
      </Section>

      <Section>
        <H2>{t("legal.privacy.use.h2")}</H2>
        <P>{t("legal.privacy.use.p1")}</P>
        <Ul>
          {bulletsUseOfData.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>
      </Section>

      <Section>
        <H2>{t("legal.privacy.cookies.h2")}</H2>
        <P>{t("legal.privacy.cookies.p1")}</P>
        <P>{t("legal.privacy.cookies.p2")}</P>
      </Section>

      <Section>
        <H2>{t("legal.privacy.security.h2")}</H2>
        <P>{t("legal.privacy.security.p1")}</P>
      </Section>

      <Section>
        <H2>{t("legal.privacy.rights.h2")}</H2>
        <P>{t("legal.privacy.rights.p1")}</P>
        <Ul>
          {bulletsRights.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>
      </Section>

      <Section>
        <H2>{t("legal.privacy.contact.h2")}</H2>
        <P>{t("legal.privacy.contact.p1")}</P>
      </Section>

      <Ornament />
    </PageWrap>
  );
}
